import { render, staticRenderFns } from "./ButtonCopy.vue?vue&type=template&id=6057248f&scoped=true&"
import script from "./ButtonCopy.vue?vue&type=script&lang=js&"
export * from "./ButtonCopy.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCopy.vue?vue&type=style&index=0&id=6057248f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6057248f",
  null
  
)

export default component.exports